import React from "react";
import { useTranslation } from "react-i18next";
import Image from "react-image-webp";
import { useHistory } from "react-router";
import { URL_CONFIG } from "../../../../_constants/Config/URL_CONFIG";
import HeadLines from "../CommonComponents/HeadLines";
import { titleCase } from "../CommonFunctions/Function";
import useUserDetails from "../CustomHooks/useUserDetails";
import style from "./style.module.css";
const LeftPart = ({ login, appLogin }) => {
  const history = useHistory();
  const userDetails = useUserDetails();
  const { t: translation } = useTranslation();
  String.prototype.isNumber = function () {
    return /^\d+$/.test(this);
  };
  let userName = userDetails?.first_name;
  if (userName) {
    userName = userName.trim().isNumber() ? "" : userName;
  }
  return (
    <>
      {!login || appLogin ? (
        <div
          className={`backgroundWhite boxRadius8 padding-bottom4 padding-top4 padding-left12 padding-right12 ${style["max-width-fit"]}`}
        >
          <Image
            src={URL_CONFIG.IMG_URL + "/home/arya-logo.png"}
            webp={URL_CONFIG.IMG_URL + "/home/arya-logo.webp"}
            alt="logo"
            className={`${style["aryaLogoCSS"]}`}
            onClick={() => {
              history.push("/");
            }}
          />
        </div>
      ) : userName ? (
        <>
          <HeadLines
            className={`textColorWhite font-weight500 `}
            text={`${translation("Hi")} ${titleCase(userName)}!`}
          />
          <HeadLines
            className={`textColorWhite font-weight400 line-height14 letterSpacing025 font-size12`}
            text="Welcome to arya.ag"
          />
        </>
      ) : (
        <HeadLines
          className={`textColorWhite font-weight500 ${style["line-height21"]}`}
          text="Welcome to arya.ag"
        />
      )}
      {/* With Login But no Name*/}
      {/* <HeadLines
        className={`textColorWhite font-weight500 ${style["line-height21"]}`}
        text="Welcome to arya.ag"
      /> */}

      {/* With Login But  Name*/}
    </>
  );
};
export default LeftPart;
